import React, { useMemo } from 'react'

import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'

import { IconNames } from 'components/icons'
import Message from 'components/message'

import {
  CheckboxContainer,
  StyledCheckbox,
  CheckedIcon,
  CheckboxChildren,
  WrapperCheckbox
} from './styled'

const Checkbox = props => {
  const handleChange = () => {
    if (!props.disabled) {
      props.onChange({ checked: !props.checked })
    }
  }
  const checkBoxId = useMemo(() => uuid(), [])
  return (
    <>
      <WrapperCheckbox>
        <CheckboxContainer
          invert={props.invert}
          padding={props.padding}
          spaceBetween={props.spaceBetween}
          e2eClass={props.e2eClass}
          name={props.name}
          width={props.disableClickOnText ? 'max-content' : props.width}
          notCentered={props.notCentered}
          onClick={handleChange}
          disabled={props.disabled}
        >
          <StyledCheckbox
            id={checkBoxId}
            e2eClass={props.e2eClass}
            disabled={props.disabled}
            small={props.small}
            rounded={props.rounded}
            checked={props.checked}
            checkAlignTop={props.checkAlignTop}
            readOnly
            onKeyDown={e => {
              if (e.key == ' ' || e.key == 'Enter') {
                e.preventDefault()
                handleChange()
              }
            }}
            aria-controls={props.ariaControls}
            aria-expanded={props.ariaControls ? props.checked : undefined}
          />
          <CheckedIcon
            name={IconNames.Check}
            color={({ theme }) => theme.colors.white}
            size={props.small ? 14 : 16}
            rounded={props.rounded}
            checked={props.checked}
            aria-hidden
          />
          {!props.disableClickOnText && (
            <CheckboxChildren htmlFor={checkBoxId} {...props}>
              {props.children || props.text}
            </CheckboxChildren>
          )}
        </CheckboxContainer>
        {props.disableClickOnText && (
          <CheckboxChildren htmlFor={checkBoxId} {...props}>
            {props.children || props.text}
          </CheckboxChildren>
        )}
      </WrapperCheckbox>
      {props.error && <Message type="formInputError">{props.error}</Message>}
    </>
  )
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  small: PropTypes.bool,
  rounded: PropTypes.bool,
  name: PropTypes.string,
  invert: PropTypes.bool,
  padding: PropTypes?.string,
  spaceBetween: PropTypes.bool,
  checkAlignTop: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  children: PropTypes.node,
  text: PropTypes.string,
  error: PropTypes.string
}

export default Checkbox
